import {auth} from "../firebase-config";
import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {setPersistence, browserLocalPersistence, signInWithEmailAndPassword} from 'firebase/auth';

function Signin() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [signInError, setSignInError] = useState('');
    const navigate = useNavigate();

    const handleSignIn = async () => {
        setSignInError('');

        try {
            await setPersistence(auth, browserLocalPersistence);
            await signInWithEmailAndPassword(auth, email, password)
            navigate("/home");
        } catch (error) {
            const authErrorMessages = {
                "auth/invalid-credential": "Invalid email or password.",
                "auth/invalid-email": "Please enter a valid email address.",
                "auth/too-many-requests": "Too many failed attempts. Please try again later."
            };
            const message = authErrorMessages[error.code] || "Sign in failed. Please check your credentials and try again.";

            setSignInError(message);
            console.error("Error signing in:", error.code, error.message);
        }
    };

    return (
        <div className="min-h-screen bg-slate-50 px-4 py-10 sm:py-16">
            <div className="mx-auto w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8">
                <h2 className="text-center text-3xl font-semibold tracking-tight text-slate-900">
                    Compitino
                </h2>
                <p className="mt-2 text-center text-sm text-slate-500">Welcome back 👋</p>

                <form
                    className="mt-8 space-y-5"
                    onSubmit={(event) => {
                        event.preventDefault();
                        handleSignIn();
                    }}
                >
                    <div className="space-y-2">
                        <label className="text-sm font-medium text-slate-600">Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setSignInError('');
                            }}
                            className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-slate-800 outline-none transition focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100"
                        />
                    </div>

                    <div className="space-y-2">
                        <label className="text-sm font-medium text-slate-600">Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setSignInError('');
                            }}
                            className="w-full rounded-xl border border-slate-200 bg-slate-50 px-3 py-2.5 text-slate-800 outline-none transition focus:border-indigo-400 focus:ring-2 focus:ring-indigo-100"
                        />
                    </div>

                    {signInError && (
                        <p className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" role="alert">
                            {signInError}
                        </p>
                    )}

                    <button
                        type="submit"
                        className="h-11 w-full rounded-xl bg-indigo-600 font-medium text-white transition hover:bg-indigo-700"
                    >
                        Sign In
                    </button>
                </form>

                <div className="my-5 flex items-center gap-3 text-xs text-slate-400">
                    <span className="h-px flex-1 bg-slate-200"/>
                    <span>or</span>
                    <span className="h-px flex-1 bg-slate-200"/>
                </div>

                <button
                    type="button"
                    className="h-11 w-full rounded-xl border border-slate-200 bg-white font-medium text-slate-700 transition hover:bg-slate-50"
                    onClick={() => navigate("/signup")}
                >
                    Create New Account
                </button>

                <p className="mt-5 text-center text-xs text-slate-400">
                    Access your tasks, notes, and planning tools in one place.
                </p>
            </div>
        </div>
    )

}


export default Signin